module.exports = __webpack_public_path__ + "static/ctaBackground-40b8b832306f7486749f209f14c09bb0.svg";